
import React, { Component } from 'react';
import { Modal, Form, Input, Switch } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

import Loading from '../../ui/Loading';

const fields = [{
    "text": "申请名称",
    "field": "flowName",
    "label": true,
}, {
    "text": "描述信息",
    "field": "des",
    "label": true,
}, {
    "text": "审核意见",
    "field": "opinion",
    "radio": true
}, {
    "text": "备注说明",
    "field": "remark",
    "textarea": true,
    rules: [
        { required: true, message: '不同意时，备注说明不能为空!' },
    ]
}];


class ChapterApplyAuditForm extends Component {

    state = {
        auditOpinion: true,
        visible: false
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ visible: true });
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }

            values["opinion"] = values["opinion"] === true ? 1 : 0;

            http.post({
                url: '/chapterApply/auditChapterApply',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("审核成功！");
                    this.setState({ visible: false });
                },
                error: (res) => {
                    messager.alert(res);
                    this.setState({ visible: false });
                }
            });
        });
    };

    changeRadio = (field, info, e) => {
        this.setState({ auditOpinion: info });
    }


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.field === "remark" ? (this.state.auditOpinion ? null : item.rules) : item.rules,
                            initialValue: editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.radio ? <Switch checkedChildren="同意" unCheckedChildren="不同意" onChange={this.changeRadio.bind(this, item.field)} />
                                : item.label ? <span>{editData[item.field]}</span>
                                    : item.textarea ? <Input.TextArea />
                                        : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={500}
                visible={visible}
                title="用章申请审核"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ auditOpinion: true }); }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 17 }}>
                    {this.createDom(fields)}
                </Form>
                <Loading visible={this.state.visible} message="数据处理中，请稍候..." />
            </Modal>
        );
    }
}

const ChapterApplyAudit = Form.create()(ChapterApplyAuditForm);

export default ChapterApplyAudit;